module.exports = __webpack_public_path__ + "static/img/T7404_message.824e5ce1.png";